import { useState, useEffect } from "react";
import {
  getAllByDokumentId,
  getCountAll,
} from "../../services/statistikaDokumenta.service";
import dokumentService from "../../services/dokument.service";
import ChartDokument from "./ChartDokument";
import PosjecenostDokumentaOdNastankaChart from "./PosjecenostDokumentaOdNastankaChart";
import { Row, Col, Button, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import SearchBar from "../../components/SearchBar";
import "./PosjecenostDokumenta.css";

const PosjecenostDokumenta = () => {
  const [dokumentId, setDokumentId] = useState(null);
  const [brojPosjeta, setBrojPosjeta] = useState(0);
  const [ukupnoPosjeta, setUkupnoPosjeta] = useState(0);
  const [dokumenti, setDokumenti] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filtriraniDokumenti, setFiltriraniDokumenti] = useState([]);

  useEffect(() => {
    const ucitajDokumente = async () => {
      try {
        const { data } = await dokumentService.getAll();
        setDokumenti(data);
      } catch (error) {}
    };
    ucitajDokumente();
  }, []);

  const dohvatiStatistiku = async (idDokumenta) => {
    if (!idDokumenta) return;

    setLoading(true);
    setDokumentId(idDokumenta);

    try {
      const { data } = await getAllByDokumentId(idDokumenta);
      setBrojPosjeta(data.length);

      const ukupnaPosjetaResponse = await getCountAll();
      setUkupnoPosjeta(ukupnaPosjetaResponse.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchTerm) {
      setFiltriraniDokumenti([]);
      setDokumentId(null);
      return;
    }

    const rezultati = dokumenti.filter((d) =>
      d.naziv.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltriraniDokumenti(rezultati);

    const exactMatch = dokumenti.find(
      (d) => d.naziv.toLowerCase() === searchTerm.toLowerCase()
    );
    if (exactMatch) {
      setDokumentId(exactMatch.id);
      dohvatiStatistiku(exactMatch.id);
      setFiltriraniDokumenti([]);
    }
  }, [searchTerm, dokumenti]);

  const handleDropdownSelect = (id) => {
    const selectedDokument = dokumenti.find((d) => d.id === id);
    if (selectedDokument) {
      setDokumentId(selectedDokument.id);
      setSearchTerm(selectedDokument.naziv);
      dohvatiStatistiku(selectedDokument.id);
      setFiltriraniDokumenti([]);
    }
  };

  const articleMenu = (
    <Menu>
      {dokumenti.map((dokument) => (
        <Menu.Item
          key={dokument.id}
          onClick={() => handleDropdownSelect(dokument.id)}
        >
          {dokument.naziv}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="posjecenost-dokumenta-div">
      <Row
        className="posjecenost-dokumenta-row.ant-row"
        align="middle"
        justify="center"
        gutter={[16, 16]}
      >
        <Col xs={24} sm={12}>
          <div className="searchbar-wrapper" style={{ width: "100%" }}>
            <Dropdown
              overlay={articleMenu}
              trigger={["click"]}
              disabled={loading}
              overlayClassName="dropdown-dokument-menu"
            >
              <Button className="ant-dropdown-button" style={{ width: "100%" }}>
                {dokumentId
                  ? dokumenti.find((d) => d.id === dokumentId)?.naziv ||
                    "Odaberite dokument"
                  : "Odaberite dokument"}{" "}
                <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="searchbar-wrapper" style={{ width: "100%" }}>
            <SearchBar
              searchTitle={searchTerm}
              setSearchTitle={setSearchTerm}
              placeholder="Pretraži dokument po nazivu..."
            />
          </div>
        </Col>
      </Row>

      {searchTerm && filtriraniDokumenti.length > 0 && (
        <ul>
          {filtriraniDokumenti.map((dokument) => (
            <li
              key={dokument.id}
              onClick={() => {
                setSearchTerm(dokument.nazic);
                handleDropdownSelect(dokument.id);
              }}
            >
              {dokument.naziv}
            </li>
          ))}
        </ul>
      )}

      {loading ? (
        <div>Učitavanje...</div>
      ) : dokumentId ? (
        <>
          <Row justify="center">
            <Col>
              <div className="posjecenost-dokumenta-div2">
                <h3 className="posjecenost-dokumenta-h3">
                  Ukupan broj posjeta dokumenta:
                </h3>
                <p>{brojPosjeta}</p>
              </div>
            </Col>
          </Row>

          <Row
            gutter={[16, 16]}
            justify="center"
            align="middle"
            style={{ width: "100%" }}
          >
            <Col xs={24} md={12} className="chart-col">
              <ChartDokument dokumentId={dokumentId} />
            </Col>
            <Col xs={24} md={12} className="chart-col">
              <PosjecenostDokumentaOdNastankaChart dokumentId={dokumentId} />
            </Col>
          </Row>
        </>
      ) : (
        <div className="posjecenost-dokumenta-tekst">
          <p>Odaberite dokument ili unesite naziv u pretragu. </p>
        </div>
      )}
    </div>
  );
};

export default PosjecenostDokumenta;
